import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';

import { AbstractAddonFacebookChat } from './facebook-chat.interface';
import { TypeAddonWindowFacebookSdk } from '../facebook.interface';


@Injectable()
export class AddonFacebookChatService extends AbstractAddonFacebookChat {

	//** Window object to access the script functions */
	private readonly window: TypeAddonWindowFacebookSdk;

	//** Helper Variables */
	isPluginLoaded: boolean = false;

	constructor(
		@Inject(DOCUMENT)
		private document: Document
	) {
		super();

		//0 - set the window object
		this.window = this.document.defaultView as TypeAddonWindowFacebookSdk;

		//1 - set the helper variable to know when the component is loaded
		this.onLoad(() => {
			this.isPluginLoaded = true;
			this.showFacebookChat();
		});
	}


	/**------------------------------------------------------
	 * Show / Hide Facebook Chat
	 */
	show(): void {

		//0 - if plugin finished loading, show it now
		if (this.isPluginLoaded) {
			this.showFacebookChat();
			return;
		}

		//1 - wait with show or hide till the chat finished loading
		this.onLoad(() => {
			this.showFacebookChat();
		});
	}

	hide(): void {

		//0 - if plugin finished loading, show it now
		if (this.isPluginLoaded) {
			this.hideFacebookChat();
			return;
		}

		//1 - wait with show or hide till the chat finished loading
		this.onLoad(() => {
			this.hideFacebookChat();
		});
	}


	/**------------------------------------------------------
	 * Subscribable Events
	 */
	onLoad(callback: () => void): Subscription {

		// Workaround:
		// > The 'customerchat.load' is the official event,
		// > but it does not trigger at the right time. The
		// > "FBChatOnLoad$" subject is used by triggering
		// > it inside the script to have an event to detect
		// > when the facebook chat finished loading
		return this.window.FBChatOnLoad$.subscribe(() => { callback(); });
	}

	onShow(callback: () => void): void {
		this.window.FB.Event.subscribe('customerchat.show', () => { callback(); });
	}

	onHide(callback: () => void): void {
		this.window.FB.Event.subscribe('customerchat.hide', () => { callback(); });
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private hideFacebookChat() {
		this.window.FB.CustomerChat.hide();
		const fbElement: HTMLElement | null = document.getElementById('fb-root');
		if (fbElement) fbElement.style.display = 'none';
	}

	private showFacebookChat() {
		this.window.FB.CustomerChat.show(false);
		const fbElement: HTMLElement | null = document.getElementById('fb-root');
		if (fbElement) fbElement.style.display = 'block';
	}
}
